
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './PurchaseSuccess.module.css';
import { useTranslation } from 'react-i18next';

const PurchaseSuccess = () => {
  const { user } = useAuth();
  const { t } = useTranslation('purchaseResult');
  return (
    <div className={styles.container}>
      <h1>{t('success.title')}</h1>
      <p>{t('success.body')}</p>
      <p>{t('success.guide')}</p>

      <Link to={user ? '/profile/my' : '/login'} className={styles.button}>
        {t('success.myPage')}
      </Link>
    </div>
  );
};

export default PurchaseSuccess;
